import { store } from 'redux/store';

import { Partner, Society } from 'types';

import { getDocument } from 'modules/documents/redux/documentActions';
import { generateDocumentWithTags } from 'utils/generateDocumentWithTags';

type GenerateCapitalHoldingCertificateProps = {
  partner: Partner | null;
  society: Society;
};

type LanguageMap = {
  [key: string]: string | undefined;
};

const getDocumentName = (partner: Partner | null): string => {
  const partnerLanguage = partner?.language || 'es';

  const defaultName = `Certificado de Partimonio - ${partner?.partnerNumber}.pdf`;

  const languageMap: LanguageMap = {
    es: defaultName,
    cat: `Certificat de Patrimoni - ${partner?.partnerNumber}.pdf`,
  };

  return languageMap[partnerLanguage] || defaultName;
};

const getCapitalHoldingCertificateDocumentId = (
  society: Society,
  partner: Partner | null
) => {
  const partnerLanguage = partner?.language || 'es';

  const languageMap: LanguageMap = {
    es: society?.templates?.capitalHoldingCertificateES,
    cat: society?.templates?.capitalHoldingCertificateCA,
  };

  return languageMap[partnerLanguage];
};

const getCapitalHoldingCertificateFooterDocumentId = (society: Society) =>
  society?.templates?.capitalHoldingCertificateFooter;

const getPartnerId = (partner: Partner | null) => partner?.['_id'];

const getDocumentIds = (society: Society, partner: Partner | null) => {
  const capitalHoldingCertificateDocumentId =
    getCapitalHoldingCertificateDocumentId(society, partner);
  const capitalHoldingCertificateFooterDocumentId =
    getCapitalHoldingCertificateFooterDocumentId(society);

  return {
    capitalHoldingCertificateDocumentId,
    capitalHoldingCertificateFooterDocumentId,
  };
};

export const generateCapitalHoldingCertificate = async ({
  partner,
  society,
}: GenerateCapitalHoldingCertificateProps) => {
  const documentName = getDocumentName(partner);

  const {
    capitalHoldingCertificateDocumentId,
    capitalHoldingCertificateFooterDocumentId,
  } = getDocumentIds(society, partner);

  const capitalHoldingCertificateFooterDocument = await store.dispatch(
    getDocument(capitalHoldingCertificateFooterDocumentId)
  );
  const partnerId = getPartnerId(partner);

  const sources = {
    partner: partnerId,
  };

  if (capitalHoldingCertificateDocumentId && partnerId) {
    await generateDocumentWithTags({
      documentId: capitalHoldingCertificateDocumentId,
      documentName,
      sources,
      language: partner?.language || 'es',
      footerHtml: capitalHoldingCertificateFooterDocument?.editorModel || '',
    });
  }
};
